import { Element, PageElement } from "../typings";

export type JsonToMjmlOption = {
  element: Element;
  pageElement?: PageElement;
  mode: "testing" | "production";
  beautify?: boolean;
  universalElements?: {
    elements: Record<string, Element>;
  };
  displayMode?: "desktop-mobile" | "only-desktop" | "only-mobile";
  keepEmptyAttributes?: boolean;
  idx?: string;
  mergetagsData?: Record<string, any>;
  attributesVariables?: Record<string, any>;
  headerElement?: Element;
  footerElement?: Element;
};

export const isProductionMode = (option: JsonToMjmlOption) =>
  option.mode === "production";
